export { default } from "./ContentPromotionDataContainer";
